"use client"

import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import "./Header.css"

const Header = ({ scrollToSection, inicioRef, serviciosRef, equipoRef, infoRef, preguntasRef }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [showServicesDropdown, setShowServicesDropdown] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)
  const toggleDropdown = () => setShowServicesDropdown(!showServicesDropdown)

  const handleQuienesSomosClick = () => {
    navigate("/Quienes")
    setIsMenuOpen(false)
    setShowServicesDropdown(false)
  }

  const handleScrollToSectionId = (sectionId) => {
    // Verificar si estamos en la página principal
    if (location.pathname !== "/") {
      // Si no estamos en la página principal, navegar primero
      navigate("/")
      // Esperar a que se cargue la página principal y luego hacer scroll
      setTimeout(() => {
        const el = document.getElementById(`legal-${sectionId}`)
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" })
        }
      }, 300)
    } else {
      // Si ya estamos en la página principal, hacer scroll directamente
      const el = document.getElementById(`legal-${sectionId}`)
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    }
    setIsMenuOpen(false)
    setShowServicesDropdown(false)
  }

  const handleNavClick = (sectionId, ref) => {
    if (location.pathname === "/" && scrollToSection && ref) {
      scrollToSection(ref)
    } else {
      navigate("/")
      setTimeout(() => {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" })
        }
      }, 300)
    }
    setIsMenuOpen(false)
    setShowServicesDropdown(false)
  }

  useEffect(() => {
    setIsMenuOpen(false)
    setShowServicesDropdown(false)
  }, [location.pathname])

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <div className="logo-wrapper">
            <img src={require("../assets/defensa2.webp") || "/placeholder.svg"} alt="Logo" className="logo-img" />
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <ul className="nav-list">
            <li className="nav-item">
              <button className="nav-link" onClick={() => handleNavClick("inicio", inicioRef)}>
                Inicio
              </button>
            </li>

            <li className="nav-item">
              <button className="nav-link" onClick={handleQuienesSomosClick}>
                Quienes Somos
              </button>
            </li>

            <li className="nav-item dropdown">
              <button className="nav-link dropdown-trigger" onClick={toggleDropdown}>
                Nuestros Servicios
                <span className={`dropdown-arrow ${showServicesDropdown ? "open" : ""}`}>▾</span>
              </button>

              <ul className={`dropdown-menu ${showServicesDropdown ? "show" : ""}`}>
                {/* <li>
                  <button className="dropdown-link" onClick={() => handleScrollToSectionId("intro")}>
                    Introducción
                  </button>
                </li> */}
                <li>
                  <button className="dropdown-link" onClick={() => handleScrollToSectionId("portafolio")}>
                    Portafolio Principal
                  </button>
                </li>
                <li>
                  <button className="dropdown-link" onClick={() => handleScrollToSectionId("especializacion")}>
                    Especialización
                  </button>
                </li>
                <li>
                  <button className="dropdown-link" onClick={() => handleScrollToSectionId("modelo")}>
                    Cuota Litis
                  </button>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <button className="nav-link" onClick={() => handleNavClick("equipo", equipoRef)}>
                Nuestro Equipo
              </button>
            </li>

            <li className="nav-item">
              <button className="nav-link" onClick={() => handleNavClick("preguntas", preguntasRef)}>
                Preguntas Frecuentes
              </button>
            </li>

            <li className="nav-item">
              <button className="nav-link" onClick={() => handleNavClick("info", infoRef)}>
                Contacto
              </button>
            </li>
          </ul>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className={`mobile-menu-btn ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>

      {/* Mobile Navigation */}
      <nav className={`mobile-nav ${isMenuOpen ? "active" : ""}`}>
        <div className="mobile-nav-content">
          <ul className="mobile-nav-list">
            <li className="mobile-nav-item">
              <button className="mobile-nav-link" onClick={() => handleNavClick("inicio", inicioRef)}>
                Inicio
              </button>
            </li>

            <li className="mobile-nav-item">
              <button className="mobile-nav-link" onClick={handleQuienesSomosClick}>
                Quienes Somos
              </button>
            </li>

            <li className="mobile-nav-item mobile-dropdown">
              <button className="mobile-nav-link mobile-dropdown-trigger" onClick={toggleDropdown}>
                Nuestros Servicios
                <span className={`mobile-dropdown-arrow ${showServicesDropdown ? "open" : ""}`}>▾</span>
              </button>

              <ul className={`mobile-dropdown-menu ${showServicesDropdown ? "show" : ""}`}>
                <li>
                  <button className="mobile-dropdown-link" onClick={() => handleScrollToSectionId("intro")}>
                    Introducción
                  </button>
                </li>
                <li>
                  <button className="mobile-dropdown-link" onClick={() => handleScrollToSectionId("portafolio")}>
                    Portafolio Principal
                  </button>
                </li>
                <li>
                  <button className="mobile-dropdown-link" onClick={() => handleScrollToSectionId("especializacion")}>
                    Especialización
                  </button>
                </li>
                <li>
                  <button className="mobile-dropdown-link" onClick={() => handleScrollToSectionId("modelo")}>
                    Cuota Litis
                  </button>
                </li>
              </ul>
            </li>

            <li className="mobile-nav-item">
              <button className="mobile-nav-link" onClick={() => handleNavClick("equipo", equipoRef)}>
                Nuestro Equipo
              </button>
            </li>

            <li className="mobile-nav-item">
              <button className="mobile-nav-link" onClick={() => handleNavClick("preguntas", preguntasRef)}>
                Preguntas Frecuentes
              </button>
            </li>

            <li className="mobile-nav-item">
              <button className="mobile-nav-link" onClick={() => handleNavClick("info", infoRef)}>
                Contacto
              </button>
            </li>
          </ul>
        </div>
      </nav>

      {/* Mobile Overlay */}
      {isMenuOpen && <div className="mobile-overlay" onClick={toggleMenu}></div>}
    </header>
  )
}

export default Header